import 'core-js/stable'
// https://stackoverflow.com/questions/44042816/what-is-wrong-with-crypto-getrandomvalues-in-internet-explorer-11
if (!window.crypto) {
  window.crypto = window.msCrypto
}
